import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {CouponState} from './slicer';
import {
  confirmCouponPreorder,
  createCouponPreorder,
  getCouponDetails,
  getCouponHistoryList,
  getCouponTemplateList,
  pauseCoupon,
  removeCoupon
} from './thunk';

export const couponBuilder = (builder: ActionReducerMapBuilder<CouponState>) => {
  builder
    .addCase(getCouponHistoryList.pending, (state: any, action: any) => {
      state.loading = true;
      if (action.meta.arg.page === 1) {
        state.historyList = null;
      }
    })
    .addCase(getCouponHistoryList.fulfilled, (state: any, action: any) => {
      const nextHistory = action.payload.data;
      state.historyList =
        nextHistory?.page > 1 && state.historyList
          ? {
              ...nextHistory,
              coupons: [...state.historyList.coupons, ...nextHistory.coupons]
            }
          : nextHistory;
      state.loading = false;
    })
    .addCase(getCouponHistoryList.rejected, (state: any) => {
      state.loading = false;
    })
    .addCase(getCouponDetails.pending, (state: any) => {
      state.loading = true;
      state.details = null;
    })
    .addCase(getCouponDetails.fulfilled, (state: any, action: any) => {
      state.details = action.payload.data;
      state.loading = false;
    })
    .addCase(getCouponDetails.rejected, (state: any) => {
      state.loading = false;
      state.details = null;
    })
    .addCase(getCouponTemplateList.pending, (state: any, action: any) => {
      state.loading = true;
      if (action.meta.arg.page === 1) {
        state.templateList = null;
      }
    })
    .addCase(getCouponTemplateList.fulfilled, (state: any, action: any) => {
      const nextTemplates = action.payload.data;
      state.templateList =
        nextTemplates?.page > 1 && state.templateList
          ? {
              ...nextTemplates,
              templates: [...state.templateList.templates, ...nextTemplates.templates]
            }
          : nextTemplates;
      state.loading = false;
    })
    .addCase(getCouponTemplateList.rejected, (state: any) => {
      state.loading = false;
    })
    .addCase(createCouponPreorder.pending, (state: any) => {
      state.create.loading = true;
    })
    .addCase(createCouponPreorder.fulfilled, (state: any) => {
      state.create.loading = false;
    })
    .addCase(createCouponPreorder.rejected, (state: any) => {
      state.create.loading = false;
    })
    .addCase(confirmCouponPreorder.pending, (state: any) => {
      state.create.loading = true;
    })
    .addCase(confirmCouponPreorder.fulfilled, (state: any) => {
      state.create.loading = false;
    })
    .addCase(confirmCouponPreorder.rejected, (state: any) => {
      state.create.loading = false;
    })
    .addCase(removeCoupon.pending, (state: any) => {
      state.remove.loading = true;
    })
    .addCase(removeCoupon.fulfilled, (state: any) => {
      state.remove.loading = false;
    })
    .addCase(removeCoupon.rejected, (state: any) => {
      state.remove.loading = false;
    })
    .addCase(pauseCoupon.pending, (state: any) => {
      state.pause.loading = true;
    })
    .addCase(pauseCoupon.fulfilled, (state: any) => {
      state.pause.loading = false;
    })
    .addCase(pauseCoupon.rejected, (state: any) => {
      state.pause.loading = false;
    });
};
